import { sanitizeHTML } from "@/lib/utils";

interface OneColumnSectionData {
  text?: {
    text?: string;
  };
}

export const fields = [
  // text
  "text.text",
] as const;

interface OneColumnSectionProps {
  data?: OneColumnSectionData;
}

export default function OneColumnSection({ data }: OneColumnSectionProps) {
  const text = data?.text?.text || "";

  return (
    <section className="w-full p-8 lg:p-32">
      <div className="container mx-auto">
        <div
          className="text-[1rem] font-normal leading-normal lg:text-[1.25rem] font-greycliff text-primary tracking-tight [&>*]:text-[1rem] [&>*]:font-normal [&>*]:leading-normal lg:[&>*]:text-[1.25rem] [&>*]:pb-6 [&>h2]:text-[2rem] [&>h2]:font-essonnes [&>h2]:font-light [&>h2]:leading-tight md:[&>h2]:text-5xl lg:[&>h2]:text-[3.375rem] [&>h2]:text-primary [&>h2]:pb-8 [&_h3]:text-[1.5rem] [&_h3]:leading-9 [&_h3]:font-essonnes [&_h3]:font-light md:[&_h3]:text-4xl md:[&_h3]:leading-[3.06rem] lg:[&_h3]:text-[2.5rem] lg:[&_h3]:leading-[3.4rem] [&_h3]:tracking-tight [&_h3]:text-primary [&_h3]:pb-8 [&>p]:pb-4 [&>p:last-child]:pb-0 [&_ul]:list-disc [&_ul]:pl-6 [&_ul]:pb-4 [&_ul>li]:mb-2 [&_ul>li:last-child]:mb-0 [&_a]:underline [&_a]:transition-all [&_a:hover]:no-underline"
          dangerouslySetInnerHTML={sanitizeHTML(text)}
        />
      </div>
    </section>
  );
} 